import React from "react";
import { Route, Switch } from "react-router";

import Doorman from "../../components/Doorman/Doorman";
import Exclusions from "./Exclusions";

const ExclusionsRoutes: React.FC = () => {
  return (
    <Switch>
      <Doorman type="admin">
        <Route exact path="/innhold/ekskluderinger" component={Exclusions} />
      </Doorman>
    </Switch>
  );
};

export default ExclusionsRoutes;
